(function ($) {
	$.mediaManager = function (element, options) {
		// **************************************************************
		// Public Properties
		// **************************************************************

		var $c = $(element), // Context 

			MediaManager = (function ($c, o) {
				var defaults = {
					loadedClass: 'loaded',
					lazyBgClass: 'lazy-bg',
					buildInClass: 'build-in',
					builtInClass: 'built-in',
					delayClass: 'build-delay'
				}; 

				var _o = {},
					_ss = null, // Source Set

					tl = null, // Build-in Timeline

					$img = null // Image
				;

				var _InitObjects = function () {
					_o = $.extend({}, defaults, o);
				},

					_GetSourceSet = function($img) {
						var srcset = $img.data('srcset')
							.replace(/\'/g, "\"")
							.replace(/\\\//g, "/");
						return JSON.parse(srcset);
					},

					_OnWayPoint = function(direction) {
						if (!$c.hasClass(_o.loadedClass)) {
							_InitLoad();
						}
					},

					_OnWindowResize = function(e) {
						_InitLoad();
					},

						_InitLoad = function() {
							// Load image
							$('img', $c).each(function() {
								_LoadImage($(this), function($img, src) {
									$img.prop('src', src);

									if ($c.hasClass(_o.lazyBgClass)) {
										$c.css('background-image', 'url('+src+')');
									}
									$c.addClass(_o.loadedClass);

									if ($c.hasClass(_o.buildInClass) && !$c.hasClass(_o.builtInClass)) {
										_BuildElementIn();
									}
								});
							});
						},

						_LoadImage = function($img, cb) {
							var ss = _GetSourceSet($img),
								src = _GetDeviceSrc(ss),
								$i = $('<img />')
									.on("load", function(e) {
										if (cb) { cb($img, src); }
									})
									.on('error', function(e) {
										console.log('Could not load image \"' +src+ '\".');
									})
									.prop('src', src)
								;
						},

						_GetDeviceSrc = function(ss) {
							var ww = $(window).width(),
								size = 'mobile';

							if (ww < 768) {
								size = 'mobile';
							} else if (ww < 1024) {
								size = 'tablet';
							} else if (ww < 1920) {
								size = 'desktop';
							} else {
								size = 'large';
							}

							var src = _FindSrcSize(ss, size);
							if (!src) {
								src = _FindSrcSize(ss, 'all');
							}

							return src;
						},

							_FindSrcSize = function(ss, size) {
								for(var i = 0, l = ss.length; i < l; i++) {
								 	if (ss[i][size]) {
								 		return ss[i][size];
								 	}
								}
							},

						_BuildElementIn = function() {
							var delay = $c.hasClass(_o.delayClass) ? 0.4 * $c.index() : 0;

							tl = new TimelineLite({
								onComplete: function() {
									$c.addClass(_o.builtInClass);
								}
							})
								.add(new TweenLite($c, 1.5, { css: { y: 0, opacity: 1 }, ease: Power4.easeOut, delay: delay }))
							;
						},

				_BindEvents = function () {
					// Set waypoint
					wp = new Waypoint({
						element: $c.get(0),
						handler: _OnWayPoint,
						offset: '75%'
					});

					$(window).resize(_OnWindowResize);
				},

				init = (function() {
					_InitObjects();
					_BindEvents();
				})();
			}) ($c, options);
	};

	$.fn.mediaManager = function (options) {
		return this.each(function () {
			if (undefined === $(this).data('mediaManager')) {
				var plugin = new $.mediaManager(this, options);
				$(this).data('mediaManager', plugin);
			}
		});
	};
})(jQuery);
